var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var QboLogging_1;
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { services } from "@quandis/qbo4.ui";
import { LogLevel } from "./ILogger.js";
import { ILoggerServiceToken } from "./ILoggerService.js";
import { findStyles, loggingStyles } from './styles.js';
import { RESOURCES, enumValue } from "./Program.js";
let QboLogging = class QboLogging extends LitElement {
    static { QboLogging_1 = this; }
    static { this.styles = [
        loggingStyles,
        findStyles
    ]; }
    static { this.logLevelNames = Object.keys(LogLevel).filter(key => isNaN(Number(key))).map(name => name.toLowerCase()); }
    constructor() {
        super();
        this.debug = false;
        this.info = false;
        this.warning = false;
        this.error = true;
        this.critial = true;
        this.window = false;
        this.logs = [];
        this.logCounts = {
            [LogLevel.Trace]: 0,
            [LogLevel.Debug]: 0,
            [LogLevel.Information]: 0,
            [LogLevel.Warning]: 0,
            [LogLevel.Error]: 0,
            [LogLevel.Critical]: 0
        };
        this.showModal = false;
        // Listen for window-level errors and log them
        this.logWindowError = (event) => {
            this.loggerService?.logError(`Caught an error: ${event.message}`, event.error, Array.isArray(event.detail) ? event.detail : [event.detail]);
        };
        // Listen for unhandled promise rejections and log them
        this.logRejection = (event) => {
            this.loggerService?.logWarning(`Unhandled promist rejection: ${event.reason}`, Array.isArray(event.detail) ? event.detail : [event.detail]);
        };
        // Add a log entry for rendering.
        this.addLog = (event) => {
            const entry = this.toLog(event);
            this.loggerService?.log(entry.logLevel, entry.message, entry.error, entry.args);
            this.logs.push(entry);
            if (this.logCounts.hasOwnProperty(entry.logLevel)) {
                this.logCounts[entry.logLevel]++;
            }
            else {
                // Initialize the count for this log level if it's not predefined
                this.logCounts[entry.logLevel] = 1;
            }
            this.requestUpdate('logs', [...this.logs]);
            this.renderLogCounts();
        };
        this.loggerService = null;
        this.addEventListener('click', (e) => {
            if (!this.showModal) {
                e.preventDefault();
                e.stopPropagation();
                this.showLogs();
            }
        });
    }
    showLogs() {
        this.showModal = true;
    }
    hideLogs() {
        this.showModal = false;
    }
    toLog(event) {
        var args = Array.isArray(event.detail) ? event.detail : [event.detail];
        const entry = {
            logLevel: event.detail?.logLevel ?? LogLevel.Information,
            message: event.detail?.message ?? `${event.type} raised from ${event.target}`,
            error: event.detail?.error ?? null,
            args
        };
        return entry;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.loggerService = services.getService(ILoggerServiceToken);
        this.logs = this.loggerService.getLogs();
        window.addEventListener(RESOURCES.WRITE_LOG, this.addLog);
        if (this.window) {
            window.addEventListener('error', this.logWindowError);
            window.addEventListener('unhandledrejection', this.logRejection);
        }
    }
    async disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener(RESOURCES.WRITE_LOG, this.addLog);
        window.removeEventListener('error', this.logWindowError);
        window.removeEventListener('unhandledrejection', this.logRejection);
    }
    renderLogCounts() {
        const slots = this.querySelectorAll('[data-loglevel]');
        slots.forEach(slot => {
            const logLevel = enumValue(LogLevel, slot.getAttribute('data-loglevel'));
            const count = this.logCounts[logLevel];
            if (count !== undefined) {
                // Update the element's content with the count
                slot.textContent = `${this.logCounts[logLevel]}`;
            }
        });
        const total = this.querySelector('[data-loglevel=total]');
        if (total !== null)
            total.textContent = `${Object.values(this.logCounts).reduce((acc, count) => acc + count, 0)}`;
    }
    render() {
        return html `<slot></slot>
        ${this.showModal ? html `
<div class="modal show" @click="${this.hideLogs}">
    <div class="modal-dialog modal-xl" role="document" @click="${e => e.stopPropagation()}">
        <div class="modal-content">
        <div class="modal-header justify-content-between" >
            <h5 class="modal-title">Error Log</h5>
            <qbo-find selector=".log-item" selectorRoot="div.modal" class="mx-auto"></qbo-find>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="${this.hideLogs}"></button>
        </div>
        <div class="modal-body">
            <div class="log-list">
        ${this.logs.filter(log => log !== null).map((log) => html `<div class="log-item ${QboLogging_1.logLevelNames[log.logLevel]}">${log.message}</div>`)}
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="${this.hideLogs}">Close</button>
        </div>
        </div>
    </div>
</div>` : ''}
    `;
    }
};
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboLogging.prototype, "debug", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboLogging.prototype, "info", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboLogging.prototype, "warning", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboLogging.prototype, "error", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboLogging.prototype, "critial", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboLogging.prototype, "window", void 0);
__decorate([
    property({ type: Array }),
    __metadata("design:type", Array)
], QboLogging.prototype, "logs", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], QboLogging.prototype, "logCounts", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboLogging.prototype, "showModal", void 0);
QboLogging = QboLogging_1 = __decorate([
    customElement('qbo-logging'),
    __metadata("design:paramtypes", [])
], QboLogging);
export { QboLogging };
//# sourceMappingURL=qbo-logging.js.map